import template from './control.dot';
const controlTemplate = template.default ? template.default : template;
export { controlTemplate };
